export class ModalsComponent {
  constructor(onGenreSelect, onDateSelect) {
    this.onGenreSelect = onGenreSelect || (() => {})
    this.onDateSelect = onDateSelect || (() => {})
    
    this.createModals()
    this.attachEventListeners()
  }

  createModals() {
    // Create genre modal
    this.genreModal = this.createGenreModal()
    document.body.appendChild(this.genreModal)
    
    // Create archive modal
    this.archiveModal = this.createArchiveModal()
    document.body.appendChild(this.archiveModal)
  }

  createGenreModal() {
    const modal = document.createElement('div')
    modal.id = 'genreModal'
    modal.className = 'modal'
    
    modal.innerHTML = `
      <div class="modal-content">
        <span class="close" id="closeGenre">&times;</span>
        <h2>Choose Your Genre</h2>
        <p>Select a music genre to explore songs from that category:</p>
        <div class="genre-grid">
        <div class="genre-btn" data-genre="daily">Daily Hit</div>
        <div class="genre-btn" data-genre="rock">Rock</div>
        <div class="genre-btn" data-genre="pop">Pop</div>
        <div class="genre-btn" data-genre="hiphop">Hip-Hop</div>
        <div class="genre-btn" data-genre="country">Country</div>
        <div class="genre-btn" data-genre="rb">R&B/Soul</div>
        <div class="genre-btn" data-genre="indie">Indie</div>
        <div class="genre-btn" data-genre="classic">Classic Hits</div>
        <div class="genre-btn" data-genre="classichiphop">Classic Hip-Hop</div>
        </div>
      </div>
    `
    
    return modal
  }

  createArchiveModal() {
    const modal = document.createElement('div')
    modal.id = 'archiveModal'
    modal.className = 'modal'
    
    const today = new Date()
    const gameStart = new Date('2024-01-01')
    const todayStr = today.toISOString().split('T')[0]
    const gameStartStr = gameStart.toISOString().split('T')[0]
    
    modal.innerHTML = `
      <div class="modal-content">
        <span class="close" id="closeArchive">&times;</span>
        <h2>Previous Games</h2>
        <p>Select any previous date to play that day's challenge:</p>
        <div class="date-picker">
          <label for="gameDateInput">Select a date to play:</label>
          <input 
            type="date" 
            id="gameDateInput" 
            min="${gameStartStr}" 
            max="${todayStr}"
            value="${todayStr}"
          >
          <button class="btn btn-primary" id="playDateBtn">Play This Date</button>
        </div>
        <div style="margin-top: 20px; padding: 15px; background: var(--bg-secondary); border-radius: 8px;">
          <h3 style="margin-bottom: 10px;">Quick Select</h3>
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)); gap: 8px;">
            <button class="btn" id="yesterdayBtn">Yesterday</button>
            <button class="btn" id="weekAgoBtn">1 Week Ago</button>
            <button class="btn" id="monthAgoBtn">1 Month Ago</button>
            <button class="btn" id="randomBtn">Random Date</button>
          </div>
        </div>
      </div>
    `
    
    return modal
  }

  attachEventListeners() {
    // Genre modal listeners
    const genreClose = this.genreModal.querySelector('#closeGenre')
    const genreButtons = this.genreModal.querySelectorAll('.genre-btn')
    
    genreClose.addEventListener('click', () => this.hideGenreModal())
    
    genreButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const genre = e.target.dataset.genre
        this.hideGenreModal()
        this.onGenreSelect(genre)
      })
    })
    
    // Archive modal listeners
    const archiveClose = this.archiveModal.querySelector('#closeArchive')
    const playDateBtn = this.archiveModal.querySelector('#playDateBtn')
    const dateInput = this.archiveModal.querySelector('#gameDateInput')
    
    archiveClose.addEventListener('click', () => this.hideArchiveModal())
    
    playDateBtn.addEventListener('click', () => {
      const selectedDate = dateInput.value
      if (selectedDate) {
        this.hideArchiveModal()
        this.onDateSelect(new Date(selectedDate))
      }
    })
    
    // Quick select buttons
    const yesterdayBtn = this.archiveModal.querySelector('#yesterdayBtn')
    const weekAgoBtn = this.archiveModal.querySelector('#weekAgoBtn')
    const monthAgoBtn = this.archiveModal.querySelector('#monthAgoBtn')
    const randomBtn = this.archiveModal.querySelector('#randomBtn')
    
    yesterdayBtn.addEventListener('click', () => {
      const yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)
      this.selectDate(yesterday)
    })
    
    weekAgoBtn.addEventListener('click', () => {
      const weekAgo = new Date()
      weekAgo.setDate(weekAgo.getDate() - 7)
      this.selectDate(weekAgo)
    })
    
    monthAgoBtn.addEventListener('click', () => {
      const monthAgo = new Date()
      monthAgo.setMonth(monthAgo.getMonth() - 1)
      this.selectDate(monthAgo)
    })
    
    randomBtn.addEventListener('click', () => {
      const gameStart = new Date('2024-01-01')
      const today = new Date()
      const randomTime = gameStart.getTime() + Math.random() * (today.getTime() - gameStart.getTime())
      const randomDate = new Date(randomTime)
      this.selectDate(randomDate)
    })
    
    // Close modals when clicking outside
    window.addEventListener('click', (e) => {
      if (e.target === this.genreModal) {
        this.hideGenreModal()
      }
      if (e.target === this.archiveModal) {
        this.hideArchiveModal()
      }
    })
    
    // ESC key to close modals
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.hideGenreModal()
        this.hideArchiveModal()
      }
    })
  }

  selectDate(date) {
    const dateInput = this.archiveModal.querySelector('#gameDateInput')
    dateInput.value = date.toISOString().split('T')[0]
    this.hideArchiveModal()
    this.onDateSelect(date)
  }

  showGenreModal() {
    this.genreModal.style.display = 'block'
    
    // Focus first genre button for accessibility
    setTimeout(() => {
      const firstBtn = this.genreModal.querySelector('.genre-btn')
      if (firstBtn) firstBtn.focus()
    }, 100)
  }

  hideGenreModal() {
    this.genreModal.style.display = 'none'
  }

  showArchiveModal() {
    this.archiveModal.style.display = 'block'
    
    // Focus date input for accessibility
    setTimeout(() => {
      const dateInput = this.archiveModal.querySelector('#gameDateInput')
      if (dateInput) dateInput.focus()
    }, 100)
  }

  hideArchiveModal() {
    this.archiveModal.style.display = 'none'
  }

  updateGenreSelection(currentGenre) {
    const genreButtons = this.genreModal.querySelectorAll('.genre-btn')
    genreButtons.forEach(btn => {
      btn.classList.remove('active')
      if (btn.dataset.genre === currentGenre) {
        btn.classList.add('active')
      }
    })
  }

  destroy() {
    // Remove modals from DOM
    if (this.genreModal && this.genreModal.parentNode) {
      this.genreModal.parentNode.removeChild(this.genreModal)
    }
    if (this.archiveModal && this.archiveModal.parentNode) {
      this.archiveModal.parentNode.removeChild(this.archiveModal)
    }
  }
}